export default __webpack_public_path__ + "static/media/martin_milkaut.559b6189.png";